import { SecurityPipelineScheduledWorkflowCadence } from "~/operations";
import { SelectOptions } from "~/types/form";
import { SecurityPipelineGithubAutomateFormValues } from "./types";

export const AUTOMATION_SCOPE = {
  SPACE: "SPACE",
  WORKSPACE: "WORKSPACE",
};

export type AutomationScope =
  (typeof AUTOMATION_SCOPE)[keyof typeof AUTOMATION_SCOPE];

// Default form values
export const DEFAULT_FORM_VALUES: SecurityPipelineGithubAutomateFormValues = {
  cadence: "",
  day: 0,
  scope: AUTOMATION_SCOPE.SPACE,
  autoCreateWorkflows: false,
  workspaceMrns: [],
};

// Type guard to check if cadence is a valid SecurityPipelineScheduledWorkflowCadence
export const isValidCadence = (
  cadence: SecurityPipelineScheduledWorkflowCadence | "",
): cadence is SecurityPipelineScheduledWorkflowCadence => {
  if (cadence === "") {
    return false;
  }
  const validCadences = Object.values(SecurityPipelineScheduledWorkflowCadence);
  return validCadences.includes(cadence);
};

// Cadence select options
export const CADENCE_OPTIONS: SelectOptions<
  SecurityPipelineScheduledWorkflowCadence | ""
> = [
  { label: "Never", value: "" },
  {
    label: "Weekly",
    value: SecurityPipelineScheduledWorkflowCadence.Weekly,
  },
  {
    label: "Monthly",
    value: SecurityPipelineScheduledWorkflowCadence.Monthly,
  },
];

// Days of week select options (0 = Monday, 6 = Sunday)
export const DAYS_OF_WEEK_OPTIONS: SelectOptions<number> = [
  { label: "Monday", value: 0 },
  { label: "Tuesday", value: 1 },
  { label: "Wednesday", value: 2 },
  { label: "Thursday", value: 3 },
  { label: "Friday", value: 4 },
  { label: "Saturday", value: 5 },
  { label: "Sunday", value: 6 },
];

// Days of month select options (1-31)
export const DAYS_OF_MONTH_OPTIONS: SelectOptions<number> = Array.from(
  { length: 31 },
  (_, i) => ({
    label: `${i + 1}`,
    value: i + 1,
  }),
);
